module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Bold-f9ddd460b7d5f4f5fa83b862600d4aa4.ttf";